/**
 * Created by yuanjianxin on 2017/5/17.
 */
import NetworkHandler from '../network/NetworkHandler';

const _allComponents = new Set();
const _eventRegistry = new Map();
//todo 引入NetWorkHandler
export default class AssistantBase {

    //构造函数
    constructor() {

        // this._moduleConfigOriginal=null;  todo 这个变量好像没用，待核实
        this._networkHandler = null;
        this._networkConfig = null;
        this._routerConfig = null;
        this._localeConfig = null;
        this._globalFunctions = null;
    }

    //配置network
    formatNetWorkHandler(httpType) {
        return new NetworkHandler(this,httpType, this._networkConfig);
    }

    get allComponents() {
        return _allComponents;
    }

    get store() {
        return this._store;
    }

    get routerConfig() {
        return this._routerConfig;
    }

    get networkHandler() {

        return this._networkHandler;
    }

    // todo 这里配置需要修改
    configNetwork(config) {
        //config.httpBaseUrl='http://'+__HOST__+(__PORT__ ? ':' : '')+__PORT__+__URL__;
        this._networkConfig = config;

    }

    configLocale(config) {
        this._localeConfig = config;
    }

    get localeConfig() {
        return this._localeConfig
    }


    configGlobalFunctions(all) {
        this._globalFunctions = all;
    }

    notify(key, ...paras) {
        var e = _eventRegistry.get(key)
        if (!e)
            return
        e.forEach((theSet, target) => theSet.forEach(func => func.call(target, ...paras)))
    }

    listen(key, target, func) {
        var e = null;
        ( e = _eventRegistry.get(key) ) || _eventRegistry.set(key, e = new Map());
        var ee = null;
        ( ee = e.get(target) ) || e.set(target, ee = new Set());
        ee.add(func)
    }

    /**
     * 取消某项或某批侦听
     * 参数 key 字符串类型，侦听的键值
     * 参数 target 对象类型，侦听的对象
     * 参数 func 函数类型，侦听的函数
     * 参数 clear 布尔类型，是否全部清除
     * 这四项的传递顺序是不重要的（只要参数类型能匹配）
     * 前三项参数可以选择性传递，如果不传，将匹配所有。
     * 常见用法：
     * 1 unListen(target)，则清除该target所有键值的所有侦听
     * 2 unListen(true)，清除全部…。注：此项慎用
     * @param paras
     */
    unListen(...paras) {
        var key, target, func, clear;
        paras.forEach(v =>
            (typeof v === 'string' && (key = v ) )
            || (typeof v === 'function' && (func = v ) )
            || ( typeof v === 'object' && (target = v ) )
            || ( typeof v === 'boolean' && ( clear = true ) )
        );
        if (!key && !target && !func && !clear)
            return;

        //console.info('=============debug111====',key,target,func,clear);
        [..._eventRegistry.entries()].forEach(([_key, _theMap]) => {
            if (key && _key !== key)
                return;
            [..._theMap.entries()].forEach(([_target, theSet]) => {
                if (target && _target !== target)
                    return;
                [...theSet].forEach(_func => ( !func || _func === func ) && theSet.delete(_func))
                if (theSet.size === 0)
                    _theMap.delete(_target)
            })
            if (_theMap.size === 0)
                _eventRegistry.delete(_key)
        })

    }

}
